import React from "react";
import { Toaster } from "sonner";
import { CheckCircle2 } from "lucide-react";

export const BookingSuccess = ({ form, onHome, onBookAnother }) => (
  <div data-testid="booking-success" className="bg-background min-h-[calc(100vh-4rem)]">
    <Toaster theme="dark" position="top-center" />
    <section className="max-w-3xl mx-auto px-6 lg:px-10 py-24 text-center">
      <div className="inline-flex h-16 w-16 border border-brand-red bg-brand-red/10 grid place-items-center mb-8">
        <CheckCircle2 className="h-7 w-7 text-brand-red" />
      </div>
      <div className="font-mono text-[10px] uppercase tracking-[0.4em] text-brand-red">Booking received</div>
      <h1 className="mt-4 font-display uppercase text-5xl sm:text-6xl tracking-tighter text-white leading-[0.9]">
        Thanks, <span className="text-brand-red">{form.customer_name.split(" ")[0] || "mate"}.</span>
      </h1>
      <p className="mt-6 text-zinc-300 max-w-xl mx-auto leading-relaxed">
        We&apos;ve received your booking and a confirmation has been sent to <span className="text-white">{form.customer_email}</span>.
        One of our team will call you on <span className="text-white">{form.customer_phone}</span> shortly to confirm your slot.
      </p>
      <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
        <button
          data-testid="booking-success-home"
          onClick={onHome}
          className="px-7 py-4 bg-brand-red text-white font-bold uppercase tracking-wider hover:bg-[#B91C2B]"
        >
          Back to home
        </button>
        <button
          data-testid="booking-success-another"
          onClick={onBookAnother}
          className="px-7 py-4 border border-white/20 text-white font-bold uppercase tracking-wider hover:border-brand-red hover:text-brand-red"
        >
          Book another service
        </button>
      </div>
    </section>
  </div>
);
